import React from "react";
import { ContentSection, GridRow, GridColumn, ButtonRenderProps } from "sprint-common-web";

import { LanguagesDataProvider } from "../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import {
    ensureVideoFileRecordDetails,
    isFileRecordDetailsEditable
} from "../../../../../../common/file-record-details/FileRecordDetails";
import {
    VideoFileRecordSoundtrackLanguagesView,
    VideoFileRecordSubtitlesLanguagesView
} from "../../../../../../common/file-record-details/languages/VideoFileRecordLanguagesSection";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import {
    EditEmbeddedSubtitleButtonAside,
    EditEmbeddedSubtitleButtonAsideProps
} from "../edit/embedded-subtitle/EditEmbeddedSubtitleButtonAside";
import {
    EditVideoSoundtrackButtonAside,
    EditVideoSoundtrackButtonAsideProps
} from "../edit/video-soundtracks/EditVideoSoundtrackButtonAside";

interface VideoFileRecordLanguagesSectionProps {
    height: number;
}

export const VideoFileRecordLanguagesSection = ({ height }: VideoFileRecordLanguagesSectionProps): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    ensureVideoFileRecordDetails(fileRecordDetails);

    const editSoundtrackButtonAside: ButtonRenderProps<EditVideoSoundtrackButtonAsideProps> = {
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditVideoSoundtrackButtonAside
    };

    const soundtrackButtons = [editSoundtrackButtonAside];

    const editSubtitleButtonAside: ButtonRenderProps<EditEmbeddedSubtitleButtonAsideProps> = {
        fileRecordId: fileRecordDetails.id,
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditEmbeddedSubtitleButtonAside
    };

    const subtitleButtons = [editSubtitleButtonAside];

    return (
        <LanguagesDataProvider>
            <GridRow>
                <GridColumn sm={6}>
                    <ContentSection
                        header="Soundtrack"
                        isLoading={isLoading}
                        testId="languages-content-section"
                        buttons={soundtrackButtons}
                    >
                        <VideoFileRecordSoundtrackLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
                    </ContentSection>
                </GridColumn>
                <GridColumn sm={6}>
                    <ContentSection
                        header="Subtitle"
                        isLoading={isLoading}
                        testId="subtitle-content-section"
                        buttons={subtitleButtons}
                    >
                        <VideoFileRecordSubtitlesLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
                    </ContentSection>
                </GridColumn>
            </GridRow>
        </LanguagesDataProvider>
    );
};
